module.exports = require("./ckb-IR");